<template>
  <div class="search-field-wrap">
    <div class="search-field">
      <div class="search-field__query">
        <search-field-input
          :value.sync="query"
          label="Vad söker du?"
          name="query"
          placeholder="Skriv t.ex. golvläggare eller butikssäljare"
          @update:value="filterSearch">
        </search-field-input>

        <search-locations></search-locations>

        <search-button></search-button>

        <search-field-results
          v-if="hasQuery"
          :competences="filteredCompetences"
          :isLoading="searchFieldsLoading"
          :professions="filteredProfessions"
          :query="query"
          @searchDone="resetSearchResults">
        </search-field-results>
      </div>

      <search-tags :tags="formatTags"></search-tags>
    </div>

    <div class="search-field-tabs-wrap">
      <af-h3 class="search-field__title">Förfina din sökning</af-h3>
      <search-tabs></search-tabs>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import SearchFieldInput from './SearchFieldInput'
import SearchLocations from './SearchLocations'
import SearchButton from './SearchButton'
import SearchFieldResults from './SearchFieldResults'
import SearchTabs from './SearchTabs'
import SearchTags from './SearchTags'
import AfH3 from '@/components/AfH3'
import gql from 'graphql-tag'
import { formatSearchTags } from '@/utils/tagHelpers'

export default {
  name: 'SearchField',
  components: {
    AfH3,
    SearchFieldInput,
    SearchLocations,
    SearchFieldResults,
    SearchTabs,
    SearchTags,
    SearchButton
  },

  data() {
    return {
      hideTabs: true,
      query: '',
      workgroups: [],
      professions: [],
      competences: [],
      filteredCompetences: [],
      filteredProfessions: [],
      searchFieldsLoading: 0
    }
  },

  computed: {
    ...mapState({
      searchQuery: state => state.query,
      skip: state => state.skip
    }),
    formatTags() {
      if (this.searchQuery && Object.keys(this.searchQuery).length > 0) {
        return formatSearchTags(this.searchQuery)
      }

      return []
    },
    hasQuery() {
      return this.query.length > 0
    }
  },

  apollo: {
    searchData: {
      query: gql`
        query SearchFields($language: LanguageCode) {
          workgroups(language: $language, path: "*") {
            name
            path
          }
          professions(language: $language, path: "*") {
            ...LeafNode
          }
          competences(language: $language, path: "*") {
            ...LeafNode
          }
        }

        fragment LeafNode on TaxonomyLeafNode {
          name
          path
        }
      `,
      loadingKey: 'searchFieldsLoading',
      variables() {
        return {
          language: 'sv'
        }
      },
      update({ workgroups, professions, competences }) {
        this.workgroups = workgroups
        this.professions = professions
        this.competences = competences

        if (this.hasQuery) {
          this.filterSearch(this.query)
        }
      }
    }
  },

  methods: {
    resetSearchResults() {
      this.query = ''
    },

    filterList(list, query) {
      return list
        .reduce((acc, curr) => acc.concat(curr), [])
        .filter(item => item.name.toLowerCase().includes(query.toLowerCase()))
        .slice(0, 10)
        .map(item => {
          const queryRegEx = new RegExp(`(${query})`, 'ig')

          const splitPath = item.path.split('.')
          let found = ''
          if (splitPath.length === 3) {
            const parentPath = splitPath.slice(0, 2).join('.')

            list[0].find(item => {
              if (item.path === parentPath) {
                return (found = item.name)
              }
            })
          }
          return {
            ...item,
            searchName: item.name.replace(queryRegEx, '<strong>$1</strong>'),
            parentName: found
          }
        })
    },

    filterSearch(query) {
      this.filteredProfessions = this.filterList(
        [this.workgroups, this.professions],
        query
      )
      this.filteredCompetences = this.filterList([this.competences], query)
    }
  }
}
</script>

<style lang="postcss" scoped>
@import '../../variables/custom-media.css';

.search-field,
.search-field-tabs-wrap {
  background-color: var(--color-geyser);
  border-radius: 4px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.25);
  margin-bottom: var(--spacing-medium);
  padding: var(--spacing) 25px;
}

.search-field {
  padding: var(--spacing) 25px var(--spacing-half);
}

.search-field-tabs-wrap {
  margin-bottom: var(--spacing-huge);
}

.search-field__query {
  align-items: flex-end;
  display: -ms-grid;
  display: grid;
  grid-column-gap: var(--spacing-medium);
  grid-template-columns: 1fr;
  -ms-grid-columns: 1fr;
  -ms-grid-rows: (1fr)[2];
  position: relative;

  @media (--bp-desktop) {
    grid-template-columns: repeat(2, 535px);
  }

  @media (--ie11) and (--bp-desktop) {
    -ms-grid-columns: (565px)[2];
    -ms-grid-rows: 1fr;
  }
}

.search-field__title {
  font-size: 22px;
  font-weight: 600;
  margin-top: 0;

  @media (--bp-larger-than-tablet) {
    display: block;
  }
}

.search-field__hide-tags {
  color: var(--color-matisse);
  cursor: pointer;
  font-size: 16px;
  text-align: right;

  @media (--bp-larger-than-tablet) {
    display: none;
  }
}

.search-field__hide-tags-icon {
  font-size: 16px;
  margin-right: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/Search/SearchField.vue